import { Action } from 'redux';

import { SetCertification } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetCertificationAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'datasource'>
    | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'> | IContentInfo<'view'>;
}

export function setCertificationAction(item: SetCertificationAction['item']): SetCertificationAction {
  return {
    type: SetCertification,
    item
  };
}
